import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCountry24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCountry24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 20.5c.9 0 1.769-.14 2.583-.4v-1.933h-1.166a3 3 0 0 1-3-3v-3.608l.386-.215 7.114-3.952V5.897a8.5 8.5 0 0 0-3.084-1.913v3.48l-.414.207-1.667.833-.387.194-.361-.239L8.75 6.311v2.947a3 3 0 0 1-3 3H3.504A8.5 8.5 0 0 0 12 20.5m-8.41-9.742h2.16a1.5 1.5 0 0 0 1.5-1.5V4.95a8.5 8.5 0 0 0-3.66 5.808M8.414 4.29A8.5 8.5 0 0 1 12 3.5q.681.001 1.334.104v2.933l-.865.432zm7.67 13.126v2.04A8.5 8.5 0 0 0 20.5 12c0-1.51-.393-2.927-1.083-4.155v.43l-.386.214-7.114 3.952v2.726a1.5 1.5 0 0 0 1.5 1.5h2.666zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCountry24);
